export default {
    'User account': 'Compte utilisateur',
    'Disconnect': 'Déconnexion',
    'Your password has been reset!': 'Votre mot de passe a été réinitialisé !',
    'An email has been sent to your address. Follow the link in that message to setup a new password.': 'Un email a été envoyé à votre adresse. Suivez le lien dans ce message pour configurer un nouveau mot de passe.',
    'Back': 'Retour',
    'Email': 'Email',
    'Reset your password': 'Réinitialiser votre mot de passe',
    'Don\'t have an account?': 'Vous n\'avez pas de compte ?',
    'Create your account': 'Créer votre compte',
    'Remembered your password?': 'Vous vous souvenez de votre mot de passe ?',
    'Sign in.': 'Se connecter.',
    'Your account has been created!': 'Votre compte a été créé !',
    'An email has been sent to your address. Follow the link in that message to confirm your registration.': 'Un email a été envoyé à votre adresse. Suivez le lien dans ce message pour confirmer votre inscription.',
    'You did not receveid the email?': 'Vous n\'avez pas reçu l\'email ?',
    'Click': 'Cliquez',
    'here': 'ici',
    'to send it again, or contact': 'pour l\'envoyer à nouveau, ou contactez',
    'Your email': 'Votre email',
    'Your password': 'Votre mot de passe',
    'Repeat your password': 'Répétez votre mot de passe',
    'By creating an account, you agree to Vodalys': 'En créant un compte, vous acceptez les conditions d\'utilisation de Vodalys',
    'You must agree the Conditions of Use': 'Vous devez accepter les conditions d\'utilisation',
    'Conditions of Use': 'Conditions d\'utilisation',
    'The password must be at least {min} characters long': 'Le mot de passe doit contenir au moins {min} caractères',
    'The passwords cannot be empty': 'Les mots de passe ne peuvent être vides',
    'The passwords do not match': 'Les mots de passe ne correspondent pas',
    'The email address you provided is not valid': 'L\'adresse email n\'est pas valide',
    'This account already exists': 'Ce compte est déjà enregistré',
    'Access denied': 'Accès non autorisé',
    'Registration failed': 'La création du compte a échoué',
    'Invalid login or password': 'Identifiant ou mot de passe invalide',
    'Create your account!': 'Créez votre compte !',
    'Already have an account?': 'Vous avez déjà un compte ?',
    'Sign in': 'Se connecter',
    'Forgot your password?': 'Mot de passe oublié ?',
    'Password': 'Mot de passe',
    'Create your account.': 'Créez votre compte.',
    'Sign in': 'Se connecter'
}